let mainPath = "/imager";
let viewFolder = "Imager";

module.exports = [
    {
        path: mainPath,
        name: 'Imager',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
    },
]